var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0418 10.5159C20.0418 10.7904 19.922 11.0511 19.7136 11.2297L16.4231 14.0501C16.2459 14.2021 16.0283 14.2765 15.8116 14.2765C15.5468 14.2765 15.2833 14.1649 15.0974 13.9482C14.7595 13.5539 14.8049 12.9603 15.1993 12.6225L16.5602 11.456H8.76011C8.24092 11.456 7.81997 11.0351 7.81997 10.5159C7.81997 9.99669 8.24092 9.57574 8.76011 9.57574H16.5602L15.1993 8.40929C14.8049 8.07142 14.7595 7.47787 15.0974 7.08354C15.4357 6.68967 16.0297 6.64422 16.4231 6.98163L19.7136 9.80206C19.922 9.98063 20.0418 10.2414 20.0418 10.5159ZM11.5805 17.0969C11.5805 18.1339 10.7373 18.9772 9.70025 18.9772H4.0594C3.02262 18.9772 2.17911 18.1339 2.17911 17.0969V3.93489C2.17911 2.89788 3.02262 2.0546 4.0594 2.0546H9.70025C10.7373 2.0546 11.5805 2.89788 11.5805 3.93489V8.16553H13.4608V3.93489C13.4608 1.86134 11.7738 0.174316 9.70025 0.174316H4.0594C1.98585 0.174316 0.298828 1.86134 0.298828 3.93489V17.0969C0.298828 19.1704 1.98585 20.8575 4.0594 20.8575H9.70025C11.7738 20.8575 13.4608 19.1704 13.4608 17.0969V12.8662H11.5805V17.0969Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutblack);
export default __webpack_public_path__ + "static/media/logoutblack.15a380719e7999d77b96c28aa5762669.svg";
export { ForwardRef as ReactComponent };